module.exports = __webpack_public_path__ + "io.svg?e952bd6a40bfd19b1dac22a4e04a0853";